
import React from 'react'
import { useThree } from '@react-three/fiber'
import { ScrollControls, Scroll } from "@react-three/drei"
import { HiddenText, ParallaxDiv, DistortImage } from '../helpers'

function Images() {
    const { width, height } = useThree((state) => state.viewport)
    const s = Math.max(width, height) * 0.07
    const m = window.innerWidth <= 650
    return (
      <group>
        <DistortImage position={[0, m ? 0 : -height*0.8, 0]} scale={[width * 0.8, width, width * 0.8]} url="images/img2.jpg" />
        <DistortImage position={[m ? 0 : -1.3*s, m ? -height * 0.88 : -height, 3]} scale={2.5*s} url="images/img4.jpg" />
        <DistortImage position={[m ? 0 : 1.8*s, m ? -height*1.5 : -height*1.25, 2]} scale={[3*s, 4.6*s, 3*s]} url="images/smoke.jpg" />
        <DistortImage position={[-2*s, -height*2, 2]} scale={4*s} url="images/img7.jpg" />
        <DistortImage position={[0, -height*2.5, 1]} scale={5*s} url="images/map.jpg" />
        <DistortImage position={[1.3*s, -height*2, 3]} scale={2.5*s} url="images/2452862c.jpg" />
        <DistortImage position={[-1.2*s, -height*2.75, 3]} scale={[2*s, 3*s, 2*s]} url="images/bathflat.jpg" />
        <DistortImage position={[1.5*s, -height*2.75, 2]} scale={[2.7*s, 4*s, 2.7*s]} url="images/circle.jpg" />
        <DistortImage position={[0, m ? -height * 3.2 : -height*3.7, 0.5]} scale={height*1.2*s} url="images/7bfb6fa7.jpg" />
        <DistortImage position={[0, -height*4, 2]} scale={4} url="images/img5.jpg" />
        <DistortImage position={[m ? -0.4 : -1.5*s, m ? -height * 4.5 : -height*4.3, 3]} scale={2.5*s} url="images/square.jpg" />
        <DistortImage position={[m ? 0.1 : 0.75*s, -height*4.3, 3.7]} scale={1.5*s} url="images/light1.jpg" />
        <DistortImage position={[m ? 0 : 0.8, -height*4.75, 3.2]} scale={[2*s, 3*s, 2*s]} url="images/gate.jpg" />
        <DistortImage position={[-2.2*s, -height*5, 1.5]} scale={[5*s, 7*s, 5*s]} url="images/ya.jpg" />
        <DistortImage position={[2.2*s, -height*5.2, 1]} scale={[5*s, 7*s, 5*s]} url="images/li22.jpg" />
      </group>
    )
  }
  
export function Gallery(props) {
    return (
      <ScrollControls
        pages={6.5} 
        damping={8}
      >
        <Scroll>
          <Images />
        </Scroll>
        <Scroll html>
        <ParallaxDiv speed={1} >
          <div className="side-text" style={{ position: 'absolute', top: '50vh', right: '-98vw', transform: 'translate(-50%, -50%)', writingMode: 'vertical-rl'}}>
            <HiddenText show single="true">
              {`scroll to discover ⟶`}
            </HiddenText>
          </div>
        </ParallaxDiv>
        </Scroll>
      </ScrollControls>
    )
}